export default __webpack_public_path__ + "static/media/apalit.d4fd00f4.jpg";